<template>
    <div>
        <label class="h1">灾情类别</label>
        <div class="type">
            <span
                v-for="(type,index) in types"
                :key="type"
                :class="{'active':index == typeIndex}"
                @click="typeIndex = index"
            >{{type}}</span>
        </div>
        <div class="address">
            <label>位置：</label>
            <span>{{address}}</span>
            <button @click="mapPopupVisible = true">选择</button>
        </div>
        <div>
            <label class="h1">灾情描述</label>
            <span class="textsize">{{remark.length}}/{{remarkMaxLength}}</span>
        </div>
        <div class="remark">
            <textarea v-model="remark"></textarea>
        </div>

        <label class="h1">照片上传</label>
        <div class="imgList">
            <div v-for="(img,index) in imgLists" :key="index">
                <img :src="img" @click="clickImg(index,img)" />
            </div>
            <div v-if="imgList.length < imgMaxNum" class="add"></div>
        </div>
        <button class="submit">上传</button>

        <mt-popup v-model="mapPopupVisible" position="right" class="mint-popup-map" :modal="false">
            <div class="addr">{{address}}</div>
            <choose-map @change-address="changeAddress"></choose-map>
            <mt-button @click.native="mapPopupVisible = false" size="large" type="primary">确认</mt-button>
        </mt-popup>

        <mt-popup
            v-model="imgPopupVisible"
            position="right"
            class="mint-popup-map bg"
            :modal="false"
        >
            <div class="img">
                <img :src="showImg" />
            </div>
            <mt-button @click.native="delImg" size="large" type="danger">删除</mt-button>
            <mt-button @click.native="imgPopupVisible = false" size="large" type="default">关闭</mt-button>
        </mt-popup>
    </div>
</template>

<script>
import chooseMap from "@/components/chooseMap.vue";

export default {
    components: { chooseMap },
    data() {
        return {
            AMap: null,
            map: null, //高德地图
            typeIndex: 0,
            types: [
                "高温",
                "火险",
                "干旱",
                "大风",
                "暴雨",
                "暴雪",
                "冰雹",
                "霜冻",
                "雷电",
                "大雾",
                "地质灾害",
                "其他"
            ],
            address: "",
            remark: "",
            remarkMaxLength: 200,
            imgMaxNum: 9,
            imgList: ["shachenbao", "snow"],
            mapPopupVisible: false,
            imgPopupVisible: false,
            showImg: null,
            showImgIndex: -1
        };
    },
    computed: {
        imgLists() {
            return this.imgList.map(name =>
                require(`../assets/background/${name}.jpg`)
            );
        }
    },
    watch: {
        remark(val) {
            if (val.length > this.remarkMaxLength) {
                this.remark = val.substring(0, this.remarkMaxLength);
            }
        }
    },

    methods: {
        changeAddress(addr) {
            this.address = addr;
        },
        clickImg(index, img) {
            this.showImg = img;
            this.showImgIndex = index;
            this.imgPopupVisible = true;
        },
        delImg() {
            this.imgPopupVisible = false;
            this.imgList.splice(this.showImgIndex, 1);
            this.showImgIndex = -1;
        }
    }
};
</script>

<style lang="less" scoped>
div {
    color: white;
}
.h1 {
    padding: 10px;
    font-size: large;
}
.textsize {
    float: right;
    margin-right: 10px;
    margin-top: 10px;
    font-size: smaller;
    color: #ddd;
}
.type {
    padding: 10px;
    > span {
        display: inline-block;
        border-radius: 5px;
        width: 25%;
        text-align: center;
        padding: 5px 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        &.active {
            background-color: #00bcd4;
        }
    }
}
.address {
    display: flex;
    padding: 10px;
    align-items: center;

    > span {
        flex: 1;
        overflow: hidden;
    }
    > button {
        border: none;
        background-color: transparent;
        border-bottom: 1px solid #cddc39;
        color: #cddc39;
        outline: none;
    }
}
.remark {
    padding: 10px;
    box-sizing: border-box;
    > textarea {
        width: 100%;
        height: 80px;
        color: white;
        box-sizing: border-box;
        border: none;
        background-color: rgba(0, 0, 0, 0.1);
        resize: none;
        outline: none;
    }
}

.imgList {
    padding: 2vw;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;

    > div {
        flex: 0 0 32vw;
        padding: 5px;
        box-sizing: border-box;

        > img {
            max-width: 100%;
            max-height: 30vw;
        }

        &.add {
            height: 32vw;
            position: relative;
            &::before {
                content: "+";
                position: absolute;
                left: 1vw;
                top: 1vw;
                bottom: 1vw;
                right: 1vw;
                text-align: center;
                line-height: 26vw;
                font-size: 5rem;
                font-weight: 100;
                border: 1px solid white;
            }
        }
    }
}

.submit {
    border: none;
    border-radius: 3px;
    padding: 10px;
    width: 90%;
    margin-left: 5%;
    margin-bottom: 20px;
    background-color: #42b947;
    color: white;
    letter-spacing: 0.3rem;
    outline: none;
    &:active {
        background-color: #4caf50;
    }
}

.mint-popup-map {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-flow: column;

    .addr {
        color: #000;
    }

    &.bg {
        background-color: rgba(0, 0, 0, 0.8);
        padding: 0 5px;
        box-sizing: border-box;
        button {
            margin-bottom: 5px;
        }
    }
    .img {
        flex: 1;
        display: flex;
        align-items: center;
        > img {
            max-width: 100%;
            max-height: 100%;
        }
    }
}
</style>